export const SPECS_SCOPE = 'site-search';

export const enum Spec {
  FluidLayout = 'specs.siteSearch.EnableFluidLayoutInSearchResultsWidget',
  ProductsSorting = 'specs.siteSearch.EnableProductsSorting',
  ShorterSearchTerm = 'specs.siteSearch.EnableShorterSearchTermQuery',
}
